import { CommonModule } from "@angular/common";
import { ChangeDetectionStrategy, Component, inject, input, ViewEncapsulation } from "@angular/core";
import { RouterModule } from "@angular/router";
import { TranslateModule } from "@ngx-translate/core";
import { AccordionModule } from "primeng/accordion";
import { MenuItem } from "primeng/api";
import { MenuModule } from "primeng/menu";

import { AuthModel } from "@intocare/auth-data";
import { NewFunctionalityTagComponent } from "@intocare/design/design-system-base";

import { AccountMenuComponent } from "../account-menu/account-menu.component";
import { IconModule } from "../icon/icon.module";

@Component({
	selector: "ic-sidebar",
	imports: [
		AccordionModule,
		AccountMenuComponent,
		CommonModule,
		IconModule,
		MenuModule,
		RouterModule,
		TranslateModule,
		NewFunctionalityTagComponent,
	],
	templateUrl: "./sidebar.component.html",
	styleUrl: "./sidebar.component.scss",
	encapsulation: ViewEncapsulation.None,
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SidebarComponent {
	private readonly authModel = inject(AuthModel);

	items = input.required<MenuItem[], MenuItem[]>({
		transform: (items) => this.enhanceWithGroupIndices(items),
	});

	protected activeGroupIndex: string;
	protected user$ = this.authModel.userName$;
	protected userMainFunctionLabel = this.authModel.userMainFunctionLabel;

	protected onMenuItemActiveChange(activeChangeEvent: boolean, groupIndex: string): void {
		if (activeChangeEvent) {
			this.activeGroupIndex = groupIndex;
		}
	}

	private enhanceWithGroupIndices(items: MenuItem[]): MenuItem[] {
		let groupIndex = 0;
		return items.map((item) => {
			const tabindex = groupIndex++;
			return {
				...item,
				...(item.items ? { tabindex: tabindex.toString() } : undefined),
			};
		});
	}
}
